<section class="title-bar content-padding first-item">
    <div class="wrapper">
        <h2 class="left">Valet Priority List</h2>
        <br class="clear">
        <div class="right">
            <a routerLink="nuovo" class="ml-10">
                <span class="btn btn-white" id="addSmsTemplate">Aggiungi<i class="ml-10 fas fa-plus"></i></span>
            </a>
        </div>
    </div>
    <br class="clear">
</section>

<section class="main-content wrapper content-padding">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage"></app-pagination>
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="priorityListFilterForm" *ngIf="priorityListFilterForm" (ngSubmit)="filter()">
            <div class="item data-col-10 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('ExpertPriority.id')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('ExpertPriority.id')"></i>
                  ID
                </h4>
                <span class="data">
                  <input type="number" min="1000" max="10000" formController="ExpertPriority.id">
                </span>
            </div>
      
            <div class="item data-col-20 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('Provinces.provinceCode')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.provinceCode')"></i>
                  Provincia
                </h4>
                <span class="data">
                  <input type="text" formControlName="Provinces.provinceCode" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                Partner
              </h4>
              <span class="data">
                <input type="text" formControlName="Partner.businessName" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('UserExpert.surname')">
                <i class="sort-icon fas" [ngClass]="orderIcon('UserExpert.surname')"></i>
                Valets
              </h4>
              <span class="data">
                <input type="text" formControlName="UserExpert.surname" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item data-col-5 hideOnPhoneView">
                <h4 class="title">Azioni</h4>
                <span class="data saifu">
                  <button class="btn hvr-grow" (click)="$event.preventDefault(); filter()">
                    <i class="fas fa-search"></i>
                  </button>
                  <button class="btn hvr-grow" (click)="$event.preventDefault(); resetFilter()">
                    <i class="fas fa-undo"></i>
                  </button>
                </span>
            </div>
            <hr class="hr-clear">
        </form>

        <div class="table-row-container row" *ngFor="let priority of expertPriorityLists">

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  ID
                </h4>
                <div class="data data-id">
                  <div>{{ priority?.id || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Province
                </h4>
                <div class="data">
                  <div>
                    <span>
                      <b>{{ priority?.province?.provinceCode }}</b>
                      {{ priority?.province?.province }}
                    </span>
                  </div>
                </div>
            </div>
        
            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Partner
                </h4>
                <div class="data">
                  <div>{{ priority?.partner?.businessName || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Valets
                </h4>
                <div class="data">
                  <div *ngIf="priority?.expertPriorities.length > 0">
                    <div *ngFor="let data of priority?.expertPriorities; let last=last;">
                      {{ data?.expert?.user?.surname }} {{ data?.expert?.user?.name }}
                      <ng-container *ngIf="!last">, </ng-container>
                    </div>
                  </div>
                  <div *ngIf="priority?.expertPriorities.length === 0">
                    ---
                  </div>
                </div>
            </div>

            <div class="item data-col-5">
                <h4 class="title"></h4>
                <span class="data saifu">
                  <button class="btn hvr-grow has-margin-right has-margin-bottom has-margin-right has-margin-top" [routerLink]="['/valet/priority-list/edit', priority?.id]">MODIFICA</button>
                  &nbsp;
                  <a (click)="$event.preventDefault(); deleteValetPriorityList(priority?.id)">
                    <span class="btn btn-red hvr-grow">Elimina<i class="ml-10 far fa-trash-alt"></i></span>
                  </a>
                </span>
            </div>
        </div>
    </div>
</section>